export default "__VITE_ASSET__pcipRBK___"